import type { DefaultOptionType } from 'antd/es/select';
import type { ShipmentRoutingUsersResponse } from './api';

export const normalizeShipmentRoutingUsers = (list: ShipmentRoutingUsersResponse): DefaultOptionType[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.text,
    value: Number(row.value),
  }));
};
